<template>
  <v-card class="rounded-lg pa-2 white" flat>
    <v-card-title class="secondary--text"> نمودار سود و زیان ویژه
      <v-spacer></v-spacer>
      <chart-export-btn page-chart-id="cost-benefit-chart"></chart-export-btn>

    </v-card-title>
    <canvas height="120" id="cost-benefit-chart"></canvas>
  </v-card>
</template>

<script>
import Chart from 'chart.js'
import ChartExportBtn from "@/components/scomponents/ChartExportBtns";

export default {
  name: 'CostAndBenefit',
  components: {ChartExportBtn},
  data() {
    return {
      chartData: {
        type: "line",
        data: {
          labels: ["فروردین", "اردیبهشت", "خرداد", "تیر", "مرداد", "شهریور", "مهر", "آبان"],
          datasets: [
            {
              label: "مبلغ",
              data: [150000, 300000, 220000, 150000, 300000, 250000, 100000, 85000],
              backgroundColor: "rgba(1, 158, 246,.04)",
              borderColor: "#019EF6",
              borderWidth: 3,
              hoverBorderWidth: 5,

            },
          ]
        },

        options: {
          title: {
            display: true,
            text: '',
            fontColor: "#000",
            fontSize: 18,
          },
          responsive: true,
          legend: {
            display: false
          },
          interaction: {
            intersect: true,
            mode: 'index',
          },
          scales: {
            xAxes: [{
              gridLines: {
                display: false,
              }
            }],
            yAxes: [
              {
                gridLines: {
                  color: "rgba(161, 161, 161, .12)",
                },
                ticks: {
                  beginAtZero: true,
                  padding: 15
                }
              }
            ]
          }
        }
      }
    }
  },
  methods : {
    getChartFromApi(){
      this.request({
        url: this.endpoint(`reports/costAndBenefitChartReport`),
        method: "get",
        success: data => {
          this.setData(data)
        }
      })
    },

    setData(data) {
      this.chartData.options.title.text = 'شرکت ' + this.company.name + '  سال مالی ' + this.financialYear.name
      this.chartData.options.title.fontSize =  13
      this.chartData.data.labels = []
      this.chartData.data.datasets[0].data = []

      for (let month of data){
        this.chartData.data.labels.push(month.title)
        this.chartData.data.datasets[0].data.push(month.amount)

      }

      this.setChart()
    },
    setChart(){
      const ctx = document.getElementById('cost-benefit-chart');
      new Chart(ctx, this.chartData);
    }

  },

  mounted() {
    this.getChartFromApi()
  }

}
</script>